/**
 * Clip path support for FireFox.
 *
 * Usage: add the 'clipPath' class to the HTML element.
 * Then, define the position and direction with the following CSS classes:
 *
 * - clipPathTopLeft: \ (start to the top-left corner)
 * - clipPathTopRight: / (start to the top-right corner)
 * - clipPathBottomLeft: \ (start to the bottom-left corner)
 * - clipPathBottomRight:  / (start to the bottom-right corner)
 */

'use strict';

require('clip-path-polygon');

/**
 * @param height Height of the divider in pixel.
 * @constructor
 */
var FrontClipPathSupport = function (height) {
    this.height = height;
};

FrontClipPathSupport.prototype = {
    init: function() {
        var $this = this;

        if (bowser.chrome === undefined || !bowser.chrome) {
            $this.createSVG();

            setTimeout(function () {
                // Bug fix: re-init the SVG on load
                $this.createSVG();
            }, 250);

            $(window).resize(function () {
                $this.deleteSVG();
                $this.createSVG();
            });
        }
    },

    /**
     * Create SVG with clipPath elements in the DOM.
     */
    createSVG: function() {
        var $this = this;

        $('.clipPath:not(.clipPathNoMobile)').each(function () {
            if ($(this).hasClass('clipPathNotMacFirefox') && (bowser.mac || bowser.windows) && bowser.firefox) {
                // Bug fix with Firefox macOs + PC (ok Linux...)
                // Do NOT render the SVG clip path
                return true;
            } else {
                var $elem = $(this).first()[0];
                $(document).ready(function () {
                    $($elem).removeAttr('style')
                });
            }

            var points = [];
            var elementHeight = Math.ceil($(this).outerHeight());
            var elementWidth = Math.ceil($(this).width());

            // Little 'hack' to get the clip path height directly from CSS
            // The targeted element must contain a .clipPathHeight div element
            var hackHeightDiv = $(this).find('.clipPathHeight').first();
            if (hackHeightDiv.length > 0) {
                var heightPx = hackHeightDiv.css('height');
                $this.height = parseInt(heightPx.replace('px', ''));
            }

            // Start to the top-left corner \
            if ($(this).hasClass('clipPathTopLeft') == true) {
                points = [
                    [0, 0], // top left
                    [elementWidth, $this.height], // top right
                    [elementWidth, elementHeight], // bottom right
                    [0, elementHeight] // bottom left
                ];
            }
            // Start to the top-right corner /
            else if ($(this).hasClass('clipPathTopRight') == true) {
                points = [
                    [0, $this.height], // top left
                    [elementWidth, 0], // top right
                    [elementWidth, elementHeight], // bottom right
                    [0, elementHeight] // bottom left
                ];
            }
            // Start to the bottom-left corner \
            else if ($(this).hasClass('clipPathBottomLeft') == true) {
                points = [
                    [0, 0], // top left
                    [elementWidth, 0], // top right
                    [elementWidth, elementHeight], // bottom right
                    [0, (elementHeight - $this.height)] // bottom left
                ];
            }
            // Start to the bottom-right corner /
            else if ($(this).hasClass('clipPathBottomRight') == true) {
                points = [
                    [0, 0], // top left
                    [elementWidth, 0], // top right
                    [elementWidth, (elementHeight - $this.height)], // bottom right
                    [0, elementHeight] // bottom left
                ];
            }

            if (points.length > 0) {
                $(this).clipPath(points, {
                    isForWebkit: false
                });
            }
        });
    },

    /**
     * Delete previously created SVG elements in the DOM.
     */
    deleteSVG: function() {
        var svg = $('[id^=clipPathPolygonGen]'); // <clipPath>

        $.each(svg, function() {
            $(this).parent().parent().remove(); // <svg>
        });
    },
};

module.exports = FrontClipPathSupport;
